import { EmploymentTypesEnum } from '../types';

export const employmentTypesWithIncome = [
  EmploymentTypesEnum.payeEmployed,
  EmploymentTypesEnum.salariedDirector,
  EmploymentTypesEnum.soleTrader,
  EmploymentTypesEnum.contractor,
  EmploymentTypesEnum.partnership,
];
